module.exports = __webpack_public_path__ + "static/media/picture3@2x.ee121c85.png";